import { InputLabel } from '@mui/material'
import IntlCurrencyInput from 'react-intl-currency-input'
import styled from 'styled-components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

export interface InputStyles {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  width?: string
  hasError?: boolean
}

export const CustomIntlCurrencyInput = styled(IntlCurrencyInput) <InputStyles>`
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
  font-family: Arial;
  width: ${({ width }) => width || '100%'};
  border: none;
  outline: none;
  border-bottom: 0.1rem solid ${COLORS.black};
  ${({ hasError }) =>
    hasError ? `border-bottom: 0.1rem solid ${COLORS.error};` : ''}

  &:focus {
    border-bottom: 0.1rem solid
      ${({ hasError }) => (hasError ? COLORS.error : COLORS.blueFonts)};
  }
`

export const InputLabelCustom = styled(InputLabel) <InputStyles>`
  font-size: ${TYPOGRAPHY.bodySize14};
  font-weight: ${FONTS.regular};
  color: ${({ hasError }) => (hasError ? COLORS.error : COLORS.black)};
  font-family: Arial;
  margin-bottom: 10px;
`
